import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from 'react-redux';
import ls from 'local-storage';

import API from '../../Services/BaseService';
import logo from '../../assets/img/Logo_final.png';
import appstore from '../../assets/img/appstore.png';
import googleplay from '../../assets/img/googleplay.png';
import LoginActions from './LoginAction';
import PageNotFound from '../FallBackUI/PageNotFound';
import '../Login/Login.css'
import { Button } from 'antd';
const Login = () => {
	const history = useHistory();
	const { state } = useLocation();
	const eye = <FontAwesomeIcon icon={faEye} />;
	const [emailId, setEmailId] = useState("");
	const [password, setPassword] = useState("");
	const [errorMessage, setErrorMessage] = useState("");
	const [errors, setErrors] = useState({ email: "", password: "" })
	const [showPwd, setShowPwd] = useState(false);

	const suuccessData = useSelector(state => state);
	const dispatch = useDispatch();
	let carId = ls.get("mailViaCarId") === null || ls.get("mailViaCarId") === "null" ? "" : ls.get("mailViaCarId")
	let soldCarId = ls.get("mailViaSoldCarId") === null || ls.get("mailViaSoldCarId") === "null" ? "" : ls.get("mailViaSoldCarId")
	console.log("login carId ======", carId, "soldCarId", soldCarId)

	const [loginErrors, setLoginErrors] = useState("");
	const [errorFlag, setErrorFlag] = useState(false);

	console.log("suuccessData======", suuccessData)
	useEffect(() => {
		if (localStorage.getItem("islogedIn") === "true") {
			localStorage.setItem("islogedIn", false);
			let request = {
				country_id: 228,
			};
			API.post('state/condition', request).then(res => {
				console.log("res", res.data.data)
			}).catch(function (error) {
				if (error.response) {
					setErrors(error.response.data.error)
					setErrorFlag(true)
				}
			});
		}
	}, [])

	function togglepwd(e) {
		e.preventDefault();
		setShowPwd(!showPwd);
	}

	const loginhandleSubmit = (event) => {
		event.preventDefault();
		setErrorMessage("")
		setErrors({ email: "", password: "" })
		console.log("inside login handle");
		if (!emailId) {
			console.log("inside email required");
			setErrors({ email: "Email Id is required", password: "" });
			return;
		} else if (emailId && !new RegExp(/^[ ]*([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})[ ]*$/i).test(emailId)) {
			console.log("email format mismatch");
			setErrors({ email: "Must match the email format", password: "" });
			return;
		} else if (!password) {
			setErrors({ email: "", password: "Password is required" });
			return
		} else {
			console.log("everything is correct");
			setErrors({ email: "", password: "" })
		}
		let request = {
			// seller_id:seller_id,
			email: emailId,
			password: password,
			application_type:"seller"

		};
		// console.log("id_____",seller_id)
		console.log("request", request);
		console.log("error", errors);
		if (!errors.email && !errors.password) {
			API.post("seller/login", request)
				.then((response) => {
					console.log("resresponse.data.data", response.data.data)

					if (response.data.success == true) {
						localStorage.setItem("islogedIn", "true")
						ls.set("backredirection", ["/carList"])
						// localStorage.setItem('sellerDetails', response.data.data);
						ls.set("sellerDetails", response.data.data)

						// ls.set('googleMapDetails', response.data?.data1[0]);
						dispatch(LoginActions.success(response.data.data))
						if (response.data.data.local_flag == '0') {
							history.push("/changepassword");
						} else {
							localStorage.setItem("islogedIn", true)
							localStorage.getItem("loadTime") !== null ? ls.set("loadTime", [localStorage.getItem("loadTime"), ...[Date.now()]]) :
								localStorage.setItem("loadTime", [Date.now()])
							// state?.from?.pathname !=="" && state?.from?.pathname !== undefined ?  history.push(state.from.pathname) :  history.push("/carList");   
							if (response.data.data.standing_id === 8 || response.data.data.standing_seller_status_id === 7) {
								history.push("/history");
							}
							else {
								if (carId == "" && soldCarId == "") {
									history.push("/carList");
									window.location.reload()
								}
								else {
									if (carId !== "") {
										history.push("/CarDetails");
									}
									else if (soldCarId !== "") {
										history.push("/soldcardetails");
									}

								}
							}

						}
						//history.push("/carlist");  							
					} else {
						setErrorMessage("Please provide correct Email/Password");
						dispatch(LoginActions.error({}))
					}
				})
				.catch(function (error) {
					if (error.response) {
						setErrors(error.response.data.error)
						setErrorFlag(true)
					}
				});
		}
	}
	return (
		<div>
			<main id="main" className="inner-page">
				{errorFlag === true ? <PageNotFound error={loginErrors} /> :
					<div className="loginblockpage">
						<div className="col-lg-4 col-md-6 col-sm-12 card loginBlock">
							<div className="dealar-login">
								<img alt="Google" src={logo} />
							</div>
							<form onSubmit={loginhandleSubmit}>
								<h2 className="title"> Seller login</h2>

								<div className="email-login">
									<div className="tbox">
										<input className="textbox " type="text" placeholder="" id="uname" name="email"
											onChange={(e) => setEmailId(e.target.value)} />
										<label htmlFor="uname" className={emailId != "" ? "input-has-value" : ""}>User Name</label>
										<p className="form-input-error">{errors.email}</p>
									</div>

									<div className="tbox">
										<input className="textbox" type={showPwd ? "text" : "password"} placeholder="" id="psw" name="password"
											onChange={(e) => setPassword(e.target.value)}
										/>
										<label htmlFor="psw" className={password != "" ? "input-has-value" : ""}>Password</label><i htmlFor="psw" className="passwordeye" onClick={togglepwd}>{eye}</i>
										<p className="form-input-error">{errors.password}</p>
									</div>
								</div>

								<div className="row">
									<div className="col-lg-6 col-md-6 col-sm-12 forget-username">
										<a className="forget-name" onClick={() => history.push("forgotEmail")} >Forgot Username</a>
									</div>
									<div className="col-lg-6 col-md-6 col-sm-12 forget">
										<a className="forget-pass" onClick={() => history.push("forgotpasswordEmail")} >Forgot Password</a>
									</div>
									<p className="form-input-error">{errorMessage}</p>
									<div className="col-lg-12 loginBtn">
										<button className="cta-btn" >LogIn</button>
										<p>Don't have an account? <Button className="forget-name" onClick={() => history.push("/registration")}> Become a Dealer</Button></p>
									</div>
								</div>
							</form>
						</div>
					</div>}

				<section id="playstoreBlock" className="playstoreBlock">
					<div className="container">
						<div className="row content">
							<div className="col-lg-12">
								<img src={appstore} />
								<img src={googleplay} />
							</div>
						</div>
					</div>
				</section>
			</main>
		</div>
	)
}

export default Login